import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { useAppSelector } from '../../../store/reduxHooks';
import {
  useGetAllQuery,
  useTestContactUsMutation,
} from '../../../services/rtkQueryServices';
import { Button, Fab, Grid } from '@mui/material';
import { ContactUsReadOnly } from './ContentForm';
import NavigationIcon from '@mui/icons-material/Navigation';

export default function ContactUsInboxPage({}: any) {
  const user = useAppSelector((state) => state.auth.user);
  const [contactUsDemoApi, { isLoading, isSuccess }] =
    useTestContactUsMutation();

  const { data, isLoading: contactDataLoading } = useGetAllQuery({
    resource: 'contact-us',
    page: 0,
    search: '',
    pageSize: 1000,
  });
  useGetAllQuery;
  return (
    <>
      {data && data.result && data.result.length === 0 && (
        <Fab
          variant='extended'
          size='medium'
          color='primary'
          aria-label='add'
          disabled={isLoading}
          sx={{ position: 'absolute', bottom: '50px', right: '50px' }}
          onClick={() =>
            contactUsDemoApi({
              body: {
                name: user.displayName,
                email: 'test@gmail.com',
                message:
                  'Testing simple contact us message sent from admin panel ' +
                  new Date().toISOString(),
              },
            })
          }
        >
          <NavigationIcon sx={{ mr: 1 }} />
          Send Demo
        </Fab>
      )}
      <GenericCrudPage
        key='contact-us-page'
        tableColumns={[
          {
            field: 'name',
            headerName: 'Name',
            width: 200,
          },
          {
            field: 'email',
            headerName: 'Email',
            width: 200,
          },
        ]}
        singularName='message'
        pageTitle='Contact Inbox'
        resource='contact-us'
        allowAdd={false}
        allowEdit={false}
        allowDelete={true}
        ReadOnlyComponent={ContactUsReadOnly}
        EditFormComponent={(data: any, setReadOnly: any) => <div />}
        newPayload={{
          title: '',
          name: '',
          about: '',
        }}
        validateFn={(data: any) => {
          return [true, []];
        }}
      />
    </>
  );
}
